import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const FAQSection = () => {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = t.faq.items;

  return (
    <section data-testid="faq-section" className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[#C89D4B] font-semibold uppercase tracking-widest text-sm">{t.faq.title}</span>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1A2332] mt-3">
            {t.faq.subtitle}
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.q}
              data-testid={`faq-${faq.q}`}
              className="border border-[#003A4B]/10 rounded-2xl overflow-hidden hover:border-[#C89D4B]/30 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === faq.q ? null : faq.q)}
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <span className="font-semibold text-[#1A2332] pr-4">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-[#C89D4B] flex-shrink-0 transition-transform ${openIndex === faq.q ? "rotate-180" : ""}`} />
              </button>
              {openIndex === faq.q && (
                <div className="px-6 pb-6 text-[#4A5568] leading-relaxed border-t border-[#003A4B]/5 pt-4">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
